import {
	aqua,
	blue,
	burnedOrange,
	darkBlueGrey,
	grey,
	lightGrey,
	orange,
	pink,
	purple,
	yellow,
} from 'inside-out/global-styles';

export const descriptionToHex = colourDescription => {
	switch (colourDescription) {
		case 'aqua':
			return aqua;
		case 'blue':
			return blue;
		case 'burned-orange':
			return burnedOrange;
		case 'dark-blue-grey':
			return darkBlueGrey;
		case 'grey':
			return grey;
		case 'light-grey':
			return lightGrey;
		case 'orange':
			return orange;
		case 'purple':
			return purple;
		case 'pink':
			return pink;
		case 'yellow':
			return yellow;
	}
};



// WEBPACK FOOTER //
// ./src/managers/colourManager.js